import { useEffect, useState } from "react";

// Subscribes to a media query so a component can avoid rendering chrome that
// CSS would only hide. The dashboard uses it for the mobile tab bar: hidden
// interactive elements still sit in the accessibility tree and would duplicate
// every sidebar link, so the bar is not rendered at all on wider screens.
//
// Breakpoints come from styles/pro-tokens.css — 1024px and 767px.
const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return undefined;

    const list = window.matchMedia(query);
    const handleChange = (event) => setMatches(event.matches);
    setMatches(list.matches);

    // Safari below 14 only has the deprecated listener API.
    if (typeof list.addEventListener === "function") {
      list.addEventListener("change", handleChange);
      return () => list.removeEventListener("change", handleChange);
    }
    list.addListener(handleChange);
    return () => list.removeListener(handleChange);
  }, [query]);

  return matches;
};

export default useMediaQuery;
